import { useEffect } from "react";
import { ColorModeContext, useMode } from "./theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./scenes/home";
import Notes from "./scenes/notes";
import RealEstateMarketplace from "./scenes/projects/RealEstateMarketplace";
import Storefront from "./scenes/projects/Storefront";
import AIFlashcards from "./scenes/projects/AIFlashcards";
import BusinessDashboard from "./scenes/projects/BusinessDashboard";
import NYUSHRateMyProfessor from "./scenes/projects/NYUSHRateMyProfessor";
import InventoryManagement from "./scenes/projects/InventoryManagement";
import CXSupport from "./scenes/projects/CXChatbot";
import ComingSoon from "./components/ComingSoon";
import AboutMe from "./scenes/home/AboutMe";
import Sep15 from "./scenes/notes/[date]/Sep15";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  // theme
  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <main className="content">
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/notes" element={<Notes />} />
              <Route path="/sept15" element={<Sep15 />} />
              {/* Project Routes */}
              <Route
                path="/businessdashboard"
                element={<BusinessDashboard />}
              />
              <Route
                path="/realestatemarketplace"
                element={<RealEstateMarketplace />}
              />
              <Route path="/cxchatbot" element={<CXSupport />} />
              <Route path="/storefront" element={<Storefront />} />
              <Route
                path="/smallbizdashboard"
                element={<BusinessDashboard />}
              />
              <Route path="/aiflashcards" element={<AIFlashcards />} />
              <Route path="/rmpassistant" element={<NYUSHRateMyProfessor />} />
              <Route
                path="/inventorymanagement"
                element={<InventoryManagement />}
              />

              {/* Other routes */}
              <Route path="/comingsoon" element={<ComingSoon />} />
              <Route path="/swe-journey" element={<AboutMe />} />

              {/* If i put the footer here, it would show for all routes not just the home route */}
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
